import { PORTFOLIO_KPIS_MOCK } from './portfolio-kpi.mock';
import type { GetPortfolioKpisResponseDto } from './portfolio-kpi.types';

/**
 * Portfolio KPI cards.
 *
 * Today: typed mock so the portfolio screen renders before the portfolio KPI route is on main.
 * Later: replace `getKpis` with fetch / generated client — keep the DTO.
 */
export const PortfolioKpiService = {
  async getKpis(): Promise<GetPortfolioKpisResponseDto> {
    await new Promise((resolve) => setTimeout(resolve, 150));
    return structuredClone(PORTFOLIO_KPIS_MOCK);
  },
};
